import api from './api';

export type OcrDocType = 'CR' | 'VAT' | 'NATIONAL_ADDRESS' | 'AUTH_LETTER';

export interface OcrResult {
  crNumber?: string;
  crExpiry?: string;
  vatNumber?: string;
  nameEn?: string;
  nameAr?: string;
  addressEn?: string;
  addressAr?: string;
  idNumber?: string;
  idType?: string;
}

export const ocrService = {
  extractDocument: async (
    file: File,
    docType: OcrDocType,
    offerId?: string,
  ): Promise<OcrResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const params = new URLSearchParams({ docType });
    if (offerId) params.append('offerId', offerId);
    const response = await api.post<OcrResult>(
      `/ocr/extract?${params.toString()}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data;
  },
};
